export default "__VITE_ASSET__CUNxe0t1__$_?nuxt_component=async&nuxt_component_name=IconFrameShapeButterfly&nuxt_component_export=default__"